import React, { memo } from "react";

const Indicator = ({ currentVal, previousVal, trend = "higher" }) => {
  const getStatus = (cur, prev, trend) => {
    let color, icon;
    if (cur < prev) {
      icon = "↓";
      color = trend === "higher" ? "red" : "green";
    } else if (cur > prev) {
      icon = "↑";
      color = trend === "higher" ? "green" : "red";
    } else {
      icon = "→";
      color = "grey";
    }

    return [color, icon];
  };

  const [color, icon] = getStatus(currentVal, previousVal, trend);

  return <span className={`indicator indicator-${color}`}>{icon}</span>;
};

export default memo(Indicator);
